import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Modal, Button, Form } from "react-bootstrap";
import { RiEyeFill, RiEyeCloseFill } from "react-icons/ri";
import Loader from "../../utilComponents/loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { changePassword } from "../../../services/adminApi.js";

const ChangePasswordModal = ({ show, handleClose }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
    if (!password) {
      return "Password is required.";
    } else if (!passwordRegex.test(password)) {
      return "Password must include one uppercase letter, one special symbol, one number, and be 8–20 characters long.";
    }
    return "";
  };

  const mutation = useMutation({
    mutationFn: changePassword,
    mutationKey: ["changePassword"],
    onSuccess: () => {
      setLoading(false);
      setOldPassword("");
      setNewPassword("");
      setPasswordError("");
      toast.success("Password changed successfully!");
      // Reset input fields
      setOldPassword("");
      setNewPassword("");
      handleClose();
    },
    onError: (error) => {
      setLoading(false);
      toast.error(
        error.response?.data?.message || "Something went wrong"
      );
      setOldPassword("");
      setNewPassword("");
      setPasswordError("");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validatePassword(newPassword);
    if (!oldPassword || !newPassword) {
      toast.error("Please fill in all fields");
      return;
    }
    if (error) {
      setPasswordError(error);
      return;
    }

    setPasswordError("");
    setLoading(true);
    mutation.mutate({ oldPassword, newPassword });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      {loading && <Loader />}
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3" style={{ position: "relative" }}>
            <Form.Label>Old Password</Form.Label>
            <div style={{ position: "relative" }}>
              <Form.Control
                type={showOldPassword ? "text" : "password"}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
              <span
                onClick={() => setShowOldPassword(!showOldPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  fontSize: "1.5rem",
                  color: "#D4AF37",
                }}
              >
                {showOldPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
              </span>
            </div>
          </Form.Group>

          <Form.Group className="mb-3" style={{ position: "relative" }}>
            <Form.Label>New Password</Form.Label>
            <div style={{ position: "relative" }}>
              <Form.Control
                type={showNewPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  setPasswordError(validatePassword(e.target.value));
                }}
                required
                className="pe-5"
              />
              <span
                onClick={() => setShowNewPassword(!showNewPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  fontSize: "1.5rem",
                  color: "#D4AF37",
                }}
              >
                {showNewPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
              </span>
            </div>
            {passwordError && (
              <div className="text-danger mt-1">
                <small>{passwordError}</small>
              </div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="warning">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
